import { makeRequest, Service, identify } from 'utils/http';

export async function getUsersAPI() {
  return makeRequest(Service.getAllUsers(await identify()));
}
